module.exports = __webpack_public_path__ + "static/idt-206a3fc65ff1c2057090e2238b000db7.svg";